module.exports = __webpack_public_path__ + "img/607-42dfb3.png";